import { render, staticRenderFns } from "./tabHolidays.vue?vue&type=template&id=5f9d80b4&scoped=true"
import script from "./tabHolidays.vue?vue&type=script&lang=js"
export * from "./tabHolidays.vue?vue&type=script&lang=js"
import style0 from "./tabHolidays.vue?vue&type=style&index=0&id=5f9d80b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9d80b4",
  null
  
)

export default component.exports